import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  title: string;
  backTo?: string;
  maxWidth?: string;
  children: ReactNode;
}

/** Card-style page wrapper for dashboard forms. */
export default function FormShell({
  title,
  backTo = '/dashboard',
  maxWidth = 'max-w-2xl',
  children,
}: Props) {
  return (
    <div className={`${maxWidth} mx-auto px-4 sm:px-6 py-8`}>
      <Link to={backTo} className="text-sm text-gray-500 hover:text-red-700 mb-4 inline-block">
        ← Quay lại
      </Link>
      <h1 className="font-display text-3xl font-extrabold text-red-700 mb-6">{title}</h1>
      {children}
    </div>
  );
}
